import { BarSeriesType } from '@mui/x-charts/models';
import { keys, uniqueArray } from '@vy/utils';
import { getBarChartColors } from './get-bar-chart-colors';

export function buildBarChartSeries(
  chartData: Record<string, number | string>[],
  dataKey: string,
): BarSeriesType[] {
  const recordsKeys = chartData.flatMap((dataPoint) => keys(dataPoint));
  const uniqueKeys = uniqueArray(recordsKeys);
  const keysWithoutDataKey = uniqueKeys.filter((key) => key !== dataKey);

  return keysWithoutDataKey.map<BarSeriesType>((key, index) => ({
    type: 'bar',
    dataKey: key,
    stack: 'stack',
    color: getBarChartColors(index),
  }));
}
